import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ResetPassword.css';  // Import the CSS file

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const location = useLocation();
  const history = useNavigate();

  const token = new URLSearchParams(location.search).get('token'); // Get token from URL

  // Function to check if the password meets the required criteria
  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // Check if the password meets the validation criteria
    if (!validatePassword(password)) {
      setError("Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_FQDN}/api/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, password }),
      });

      if (response.ok) {
        alert('Password reset successfully');
        history('/login');
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to reset password');
      }
    } catch (error) {
      setError('Error resetting password');
    }
  };

  return (
    <div className="password-container">
      <div className="password-box">
        <h2>Reset Password</h2>
        <p>Password must be at least 8 characters long, include an uppercase letter, a number, and a special character @ $ ! % * ? & #.</p>
        {error && <p className="password-error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />
          <input
            type="password"
            className="password-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            required
          />
          <button type="submit" className="password-button">Reset Password</button>
        </form>
        
      </div>
    </div>
  );
};

export default ResetPassword;
